import React from "react"
import { Link } from "react-router-dom"

export default function ServiceDetails1() {
	return (
		<>
			<section className="service-details-section section-padding">
				<div className="container">
					<div className="service-details-wrapper">
						<div className="row g-4">
							<div className="col-12 col-lg-8">
								<div className="service-details-image">
									<img src="assets/img/service/Decorative door-1.jpg" alt="img" />
								</div>
								<div className="service-details-content">
									<h2>Decorative Doors</h2>
									<p className="mt-4 mb-4">
										V-Make’s Decorative Doors bring together style, strength, and sustainability to redefine modern interior and exterior spaces. Crafted using advanced Wood-Plastic Composite (WPC) technology, these doors offer the rich aesthetics of natural wood with enhanced resistance to moisture, termites, and daily wear. Their durable, eco-friendly design ensures they maintain shape and finish over time — without warping or cracking. Perfect for residential, commercial, or designer applications, V-Make Decorative Doors deliver long-lasting elegance and performance with minimal maintenance, making them a smart choice for contemporary living.									</p>
									{/* <p className="mt-4 mb-4">
										There are many variations of passages of Lorem Ipsum
										available, but the majority have suffered alteration in some
										form, by injected humour, or randomised words which don't
										look even slightly believable. If you are going to use a
										passage of Lorem Ipsum,
									</p> */}
									<div className="row g-4">
										<div className="col-lg-7">
											<div className="service-details-image">
												<img src="assets/img/service/Decorative-2.jpg" alt="img" />
											</div>
										</div>
										<div className="col-lg-5">
											<div className="content">
												<h3>Key Benefits:</h3>
												{/* <p className="mt-2 mb-2">
												100% waterproof and termite-proof
												</p>
												<p>
													Trastek h variations of be passages of Lorem Ipsum
													available,
												</p> */}
											</div>
											<ul className="details-list">
												<li>
													<i className="fa-solid fa-circle-check" />
													100% waterproof and termite-proof
												</li>
												<li>
													<i className="fa-solid fa-circle-check" />
													Lead-Free & Safe Indoors
												</li>
												<li>
													<i className="fa-solid fa-circle-check" />
													No Warping, Swelling, or Delamination
												</li>
												<li>
													<i className="fa-solid fa-circle-check" />
													Perfect for CNC Work
												</li>
												<li>
													<i className="fa-solid fa-circle-check" />
													Works with All Finishes
												</li>
												<li>
													<i className="fa-solid fa-circle-check" />
													Weather-Resistant
												</li>
												{/* <li>
													<i className="fa-solid fa-circle-check" />
													Lightweight, Yet Strong and Long-Lasting
												</li> */}
											</ul>
										</div>
									</div>
									{/* <h4 className="mt-4">Specifications & Dimensions</h4>
									<p className="mt-3">
										V-Make WPC Foam Boards are available in multiple thicknesses and sheet sizes to suit a wide range of applications—from modular furniture and CNC work to interior paneling. Choose from standard sizes or request custom cuts based on your project needs. Lightweight, durable, and always ready for precision work.
									</p> */}
									{/* <div className="row g-4 mt-2">
										<div className="col-12">
											<div className="specifications-table" style={{ border: '1px solid #eee', padding: '25px', borderRadius: '5px' }}> */}
												{/* <div className="spec-item">
													<h5 style={{ fontWeight: '600', marginBottom: '15px' }}>V-make WPC Gold:</h5>
													<div className="spec-values" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>25 mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>28 mm</span>
													</div>
												</div> */}



												{/* <div className="spec-item mt-4">
													<h5 style={{ fontWeight: '600', marginBottom: '15px' }}>Product Sizes:</h5>
													<div className="spec-values product-sizes" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>78X27</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>78X30</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>81X27</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>81X30</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>81X32</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>81X33</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>81X36</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>81X38</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>84X27</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>84X30</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>84X33</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>84X36</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>96X30</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>96X33</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>96X36</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>96X48</span>
													</div>
												</div> */}

												{/* <div className="spec-item mt-4">
													<h5 style={{ fontWeight: '600', marginBottom: '15px' }}>V-make Gold PVC Foam Board :</h5>
													<div className="spec-values" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>5mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>8mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>12mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>17mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>18mm</span>
													</div>
												</div> */}
												{/* <div className="spec-item mt-4">
													<h5 style={{ fontWeight: '600', marginBottom: '15px' }}>V-make WPC Diamond Foam Board :</h5>
													<div className="spec-values" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>6mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>8mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>12mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>18mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>18mm +</span>
													</div>
												</div> */}
												{/* <div className="spec-item mt-4">
													<h5 style={{ fontWeight: '600', marginBottom: '15px' }}>V-make WPC UV Coated Foam Board :</h5>
													<div className="spec-values" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>6mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>8mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>12mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>18mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>18mm +</span>
													</div>
												</div> */}
												{/* <div className="spec-item mt-4">
													<h5 style={{ fontWeight: '600', marginBottom: '15px' }}>V-make Structure WPC Foam Board :</h5>
													<div className="spec-values" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>6mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>8mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>12mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>18mm</span>
														<span className="spec-value" style={{ background: '#f8f9fa', padding: '8px 15px', borderRadius: '4px', color: '#333', fontWeight: '500' }}>18mm +</span>
													</div>
												</div> */}
											{/* </div>
										</div>
									</div> */}
									{/* <h4>WPC Door Frame Installation Steps</h4>
									<p className="mt-3">
										Choosing the right door frame is just as important as the door itself. At V-Make, our WPC door frames are built for strength, precision, and long-term performance — all while being 100% waterproof and termite-proof. Here’s how easy it is to get started :
									</p>
									<div className="row g-4 mt-2">
										<div className="col-xl-4 col-lg-6 col-md-6" >
											<div className="service-details-box" style={{ height: '200px' }}>
												<div className="icon">
													<img src="assets/img/icon/16.svg" alt="img" />
													<h5>Measure & Plan</h5>
												</div>
												<p>
													Share your door opening measurements and space type for the perfect WPC frame fit.{" "}
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-6 col-md-6">
											<div className="service-details-box" style={{ height: '200px' }}>
												<div className="icon">
													<img src="assets/img/icon/15.svg" alt="img" />
													<h5>Choose Your Frame</h5>
												</div>
												<p>
													Choose frame thickness and series type based on your needs.{" "}
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-6 col-md-6">
											<div className="service-details-box" style={{ height: '200px' }}>
												<div className="icon">
													<img src="assets/img/icon/17.svg" alt="img" />
													<h5>Confirm & Deliver</h5>
												</div>
												<p>
													We'll deliver your custom WPC frames ready for installation.{" "}
												</p>
											</div>
										</div>
									</div>
									<p className="mt-1 pt-4">
										V-Make WPC door frames offer a perfect blend of durability, design flexibility, and hassle-free installation. Whether for homes or commercial spaces, they’re built to last — with zero compromise on quality.

									</p> */}
								</div>
							</div>
							<div className="col-12 col-lg-4">
								<div className="main-sidebar">
									{/* <div className="single-sidebar-widget">
										<div className="search-widget">
											<form action="#">
												<input type="text" placeholder="Search" />
												<button type="submit">
													<i className="fa-solid fa-magnifying-glass" />
												</button>
											</form>
										</div>
									</div> */}
									<div className="single-sidebar-widget">
										<div className="wid-title">
											<h3>Other Products</h3>
										</div>
										<div className="news-widget-categories">
											<ul>
												<li>
													<Link to="/Wpc-Doors">V-Make WPC Doors </Link>{" "}
													<Link to="/Wpc-Doors">
														<span>
															<i className="fa-regular fa-arrow-right-long" />
														</span>
													</Link>
												</li>
												<li>
													<Link to="/Wpc-Door-Frames">V-Make WPC Door Frames</Link>{" "}
													<Link to="/Wpc-Door-Frames">
														<span>
															<i className="fa-regular fa-arrow-right-long" />
														</span>
													</Link>
												</li>
												<li>
													<Link to="/Wpc-Foam-Board">V-Make Wpc Foam Board </Link>{" "}
													<Link to="/Wpc-Foam-Board">
														<span>
															<i className="fa-regular fa-arrow-right-long" />
														</span>
													</Link>
												</li>
												<li>
													<Link to="/Wpc-UV-Digital-Series">V-Make WPC UV Digital Series</Link>{" "}
													<Link to="/Wpc-UV-Digital-Series">
														<span>
															<i className="fa-regular fa-arrow-right-long" />
														</span>
													</Link>
												</li>
												<li>
													<Link to="/Wpc-Printed-Doors">V-Make WPC Printed Doors</Link>{" "}
													<Link to="/Wpc-Printed-Doors">
														<span>
															<i className="fa-regular fa-arrow-right-long" />
														</span>
													</Link>	
												</li>
												{/* <li>
													<Link to="/Decorative-Doors">V-Make Decorative Doors</Link>{" "}
													<Link to="/Decorative-Doors">
														<span>
															<i className="fa-regular fa-arrow-right-long" />
														</span>
													</Link>	
												</li> */}
												{/* <li>
													<Link to="/service-details">Construction</Link>
													<span>
														<i className="fa-regular fa-arrow-right-long" />
													</span>
												</li> */}
												{/* <li className="active">
													<Link to="/service-details">Factory</Link>
													<span>
														<i className="fa-regular fa-arrow-right-long" />
													</span>
												</li>
												<li>
													<Link to="/service-details">Industry</Link>{" "}
													<span>
														<i className="fa-regular fa-arrow-right-long" />
													</span>
												</li>
												<li>
													<Link to="/service-details">Real Estate</Link>{" "}
													<span>
														<i className="fa-regular fa-arrow-right-long" />
													</span>
												</li> */}
											</ul>
										</div>
									</div>
									<div className="single-sidebar-widget">
										<div className="wid-title">
											<h3>Download</h3>
										</div>
										{/* <div className="brochures-download-items">
											<div className="brochures-items">
												<div className="icon">
													<i className="fal fa-file-pdf" />
												</div>
												<div className="content">
													<h5>Our Brochures</h5>
													<p>Download</p>
												</div>
											</div>
											<Link to="/service-details" className="download-btn">
												<i className="fa-light fa-download" />
											</Link>
										</div> */}
										<div className="brochures-download-items">
											<div className="brochures-items">
												<div className="icon">
													<i className="fal fa-file-pdf" />
												</div>
												<div className="content">
													<h5>catalogue</h5>
													<p>Download</p>
												</div>
											</div>
											<Link
												to="https://drive.google.com/file/d/1hO90s74ZE1JCchHXpuGMqdhWvjS5f4-I/view?usp=sharing"
												className="download-btn active"
											>
												<i className="fa-light fa-download" />
											</Link>
										</div>
									</div>
									<div className="service-sidebar-widget">
										<div
											className="contact-bg text-center bg-cover"
											style={{
												backgroundImage:
													'url("assets/img/service/shake.jpg")',
											}}
										>
											{/* <p>Do You Need Help? We're Here to Support You</p> */}
											{/* <img src="assets/img/service/logo.png" alt="img" /> */}
											<Link to="/contact" className="theme-btn w-100">
												Contact us now
												<i className="fa-regular fa-arrow-right" />
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}
